var WDN = WDN || {};

if (typeof WDN.CartDrawer === "undefined") {
  WDN.CartDrawer = (function () {
    var init, isRendered;

    var loading, loadStyles;
    var refresh, onRefresh;

    // Depends on
    var SectionRenderer = WDN.SectionRenderer;

    var drawer = document.querySelector("wdn-drawer[data-id='cart']");

    var state = {
      rendered: false,
      stylesLoaded: false,
    };

    isRendered = function () {
      return state.rendered;
    };

    onRefresh = function () {
      state.rendered = true;

      // Configure shipping
      if (WDN.Shipping) {
        WDN.Shipping.reselectNodes();
        WDN.Shipping.outputPrices();
      }
      loading(false);
    };

    /*
      Config options:
        @openDrawer: true/false
    */

    loading = function (isLoading) {
      if (isLoading) {
        drawer.setAttribute("data-loading", "");
        return;
      }
      drawer.removeAttribute("data-loading");
    };

    loadStyles = function () {
      if (state.stylesLoaded) return;
      WDN.StylesheetLoader.load(".cartdrawer-style");
      state.stylesLoaded = true;
    };

    refresh = function (config = {}) {
      loadStyles();

      loading(true);

      WDN.CartCount.update();

      new SectionRenderer({
        selectors: {
          output: "[data-cartdrawer-content]",
        },
        autoInit: true,
        replaceOutput: true,
        sections: ["async-cart-drawer"],
        callback: function () {
          onRefresh();
          if (config.on_dom_update) {
            config.on_dom_update();
          }
          if (!config.openDrawer) return;
          drawer.open();
        },
      });
    };

    init = function () {
      var renderer = new SectionRenderer({
        selectors: {
          trigger: "wdn-drawer-open[data-id='cart']",
          output: "[data-cartdrawer-content]",
        },
        replaceOutput: true,
        sections: ["async-cart-drawer"],
        events: ["mouseover", "click"],
        callback: onRefresh,
      });

      // Setup callback for interaction (pre-fetch)
      renderer.onInteraction = function () {
        loadStyles();
      };
    };

    init();

    return {
      refresh,
      isRendered,
    };
  })();
}

/* Cart drawer multigift */
if (typeof WDN.CartMultiGift === "undefined") {
  WDN.CartMultiGift = (function () {
    class CartMultiGift extends HTMLElement {
      constructor() {
        super();
      }

      onFormSubmit(e) {
        e.preventDefault();
        let form = e.currentTarget;
        let submitButton = form.querySelector("button");

        submitButton.disabled = true;

        // Handles both cart add & cart remove request
        fetch(form.getAttribute("action") + ".js", {
          method: "POST",
          body: new FormData(form),
        })
          .then((res) => {
            WDN.CartDrawer.refresh();
          })
          .catch(() => {
            submitButton.disabled = false;
          });
      }

      removeGiftsFromCart() {
        // Generate payload based on line keys array
        let payload = {};
        this.lineKeys.forEach((key) => {
          payload[key] = 0;
        });

        // Send cart update request and remove cart items
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({ updates: payload }),
        }).then((res) => {
          WDN.CartDrawer.refresh();
        });
      }

      connectedCallback() {
        // Nodes
        this.forms = this.querySelectorAll("form");
        this.dump = JSON.parse(this.querySelector("script").innerText);

        // Properties
        this.cartSubtotalPrice = parseInt(this.dump.subtotal);
        this.giftsInCart = parseInt(this.dump.giftsInCart);
        this.threshold = parseInt(this.dump.threshold);
        this.lineKeys = this.dump.giftLineKeys.split(",");

        // If cart subtotal less than threshold and there are gifts in the cart - remove them
        if (this.cartSubtotalPrice < this.threshold && this.giftsInCart > 0) {
          this.removeGiftsFromCart();
          return;
        }

        // Bind
        this.onFormSubmitBound = this.onFormSubmit.bind(this);
        this.forms.forEach((form) =>
          form.addEventListener("submit", this.onFormSubmitBound)
        );
      }

      disconnectedCallback() {
        this.forms.forEach((form) =>
          form.removeEventListener("submit", this.onFormSubmitBound)
        );
      }
    }

    class CartMultiGiftRemover extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.lineKeys = this.getAttribute("data-line-keys").split(",");
        if (this.lineKeys[0] === "") return;
        let payload = {};
        this.lineKeys.forEach((key) => {
          payload[key] = 0;
        });

        // Send cart update request and remove cart items
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({ updates: payload }),
        }).then((res) => {
          WDN.CartDrawer.refresh();
        });
      }
      disconnectedCallback() {}
    }
    customElements.define("cart-multigift-remover", CartMultiGiftRemover);
    customElements.define("cart-multigift", CartMultiGift);
    return CartMultiGift;
  })();
}

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    this.feedback_field = this.querySelector(".code-invalid-feedback");
  }

  updateAddButtons(discount_code) {
    this.addButtons =
      this.addButtons || this.querySelectorAll('button[data-action="add"]');

    this.addButtons.forEach((elem) => {
      elem.dataset.discount_code = discount_code;
    });
  }

  _handleButtonActions() {
    /* handle add / remove of discount code */
    if (this.querySelector("button")) {
      this.addEventListener("click", (e) => {
        if (e.target.tagName === "BUTTON") {
          let button_action = e.target.dataset.action;
          let discount_code = e.target.dataset.discount_code;

          if (button_action == "add") {
            if (discount_code.length > 1) {
              this.asyncUpdateDiscountCode(discount_code);
            }
          }
        }
      });
    }
  }

  asyncUpdateDiscountCode(discount_code) {
    var formData = new FormData();
    formData.append("discount", discount_code);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        let foundAddedDiscount = data.discount_codes.find((elem) => {
          return elem.code == discount_code;
        });

        if (foundAddedDiscount) {
          if (foundAddedDiscount.applicable) {
            WDN.CartDrawer.refresh({
              on_dom_update: () => {
                document
                  .querySelector(".cartdrawer_discountcodes")
                  .scrollIntoView();
              },
            });
          } else {
            this.feedback_field.classList.remove("hidden");
          }
        }
      });
  }

  _handleFormActions() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();

      if (this.querySelector('input[name="discount-code"]')) {
        let discount_code = this.querySelector(
          'input[name="discount-code"]'
        ).value;
        this.asyncUpdateDiscountCode(discount_code);
      }
    });
  }

  _handleInputActions() {
    if (this.querySelector('input[name="discount-code"]')) {
      /* update add button value dynamically */
      this.querySelector('input[name="discount-code"]').addEventListener(
        "keyup",
        (e) => {
          if (e.target.tagName === "INPUT") {
            this.feedback_field.classList.add("hidden");
            this.updateAddButtons(e.target.value);
          }
        }
      );
    }
  }

  connectedCallback() {
    this._handleFormActions();
    this._handleButtonActions();
    this._handleInputActions();
  }
}

customElements.define("discount-code", DiscountCode);
